import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import VueGoogleCharts from 'vue-google-charts'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useAuthStore } from '@/store/store';
import Vue3Lottie from 'vue3-lottie'
import { createHead } from '@vueuse/head'

const app = createApp(App);
const head = createHead()

import { createPinia } from 'pinia'
import './registerServiceWorker'
const pinia = createPinia()
// Registre o Vue Router
app.use(router);
app.use(pinia);


app.use(head)

app.use(VueGoogleCharts);
app.use(Vue3Lottie)

const authStore = useAuthStore();
authStore.carregarDadosPersistidos();
// Monte o aplicativo no elemento com o ID "app"
app.mount('#app');
